import keycloak from "../keycloak";

const LOGIN_PORTAL_KEY = "marketplace_requested_login_portal";

const buildRedirectUri = (path) => {
  const basePath = process.env.PUBLIC_URL || "";
  return `${window.location.origin}${basePath}${path}`;
};

const persistRequestedPortal = (portal) => {
  if (!portal) {
    return;
  }

  try {
    window.sessionStorage.setItem(LOGIN_PORTAL_KEY, portal);
  } catch (error) {
    // ignore storage failures
  }
};

const clearRequestedPortal = () => {
  try {
    window.sessionStorage.removeItem(LOGIN_PORTAL_KEY);
  } catch (error) {
    // ignore storage failures
  }
};

const getRequestedPortal = () => {
  try {
    return window.sessionStorage.getItem(LOGIN_PORTAL_KEY) || "";
  } catch (error) {
    return "";
  }
};

const doLogin = (options = {}) => {
  if (options.portal) {
    persistRequestedPortal(options.portal);
  }

  const { portal, redirectPath, ...loginOptions } = options;
  return keycloak.login({
    redirectUri: buildRedirectUri(redirectPath || "/dashboard"),
    ...loginOptions,
  });
};

const doRegister = () =>
  keycloak.register({
    redirectUri: buildRedirectUri("/dashboard"),
  });

const doLogout = (options = {}) => {
  clearRequestedPortal();
  return keycloak.logout({
    redirectUri: buildRedirectUri(options.redirectPath || "/dashboard"),
  });
};

const getToken = () => keycloak.token;
const isLoggedIn = () => Boolean(keycloak.authenticated && keycloak.token);
const getRealmRoles = () =>
  keycloak.tokenParsed?.realm_access?.roles || [];
const hasRealmRole = (role) => getRealmRoles().includes(role);
const isCustomer = () => hasRealmRole("user");
const isSeller = () => hasRealmRole("seller");
const isAdmin = () =>
  ["admin", "realm-admin", "seller-admin"].some((role) => hasRealmRole(role));

const startPortalLogin = (portal) => {
  const redirectPathByPortal = {
    admin: "/admin/venditori",
    customer: "/dashboard",
    vendor: "/seller-richieste",
  };

  return doLogin({
    portal,
    redirectPath: redirectPathByPortal[portal] || "/dashboard",
  });
};

const isPortalAllowed = (portal) => {
  if (!portal) {
    return true;
  }

  if (portal === "admin") {
    return isAdmin();
  }

  if (portal === "vendor") {
    return isSeller();
  }

  if (portal === "customer") {
    return isCustomer();
  }

  return true;
};

const consumeRequestedPortal = () => {
  const portal = getRequestedPortal();
  clearRequestedPortal();
  return portal;
};

const updateToken = (successCallback) =>
  keycloak.updateToken(30).then(successCallback).catch(doLogin);
const getParsedToken = () => keycloak.tokenParsed;
const getValidToken = async () => {
  if (!keycloak.authenticated || !keycloak.token) {
    return null;
  }

  try {
    await keycloak.updateToken(30);
    return keycloak.token;
  } catch (error) {
    doLogin();
    return null;
  }
};

const UserService = {
  clearRequestedPortal,
  consumeRequestedPortal,
  doLogin,
  doRegister,
  doLogout,
  getParsedToken,
  getRealmRoles,
  getRequestedPortal,
  getToken,
  getValidToken,
  hasRealmRole,
  isAdmin,
  isCustomer,
  isLoggedIn,
  isPortalAllowed,
  isSeller,
  startPortalLogin,
  updateToken,
};

export default UserService;

